/** Capture credentials before deleting browser storage; do not enter the SDK's
 * auth lock while it may already be handling a failed refresh. */
export function startServerSessionCleanup(accessToken: string | null, serverUrl: string, publicKey: string, send: typeof fetch = fetch): Promise<void> {
  if (!accessToken || !serverUrl || !publicKey) return Promise.resolve();
  const headers = { Authorization: `Bearer ${accessToken}`, apikey: publicKey, "Content-Type": "application/json" };
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1200);
  return (async () => {
    try {
      await send(`${serverUrl}/rest/v1/rpc/release_account_session`, { method: "POST", headers, body: "{}", signal: controller.signal, keepalive: true });
    } catch { /* offline: recovery remains available; never presume release */ }
    try {
      await send(`${serverUrl}/auth/v1/logout?scope=local`, { method: "POST", headers, signal: controller.signal, keepalive: true });
    } catch { /* local lockout must still be immediate */ }
  })().finally(() => clearTimeout(timeout));
}